(() => {
  const params = new URLSearchParams(window.location.search);
  const testZipcode = (params.get('testzipcode') || '').trim();

  if (!/^\d{5}(?:-\d{4})?$/.test(testZipcode)) return;

  const cacheKey = `rtq_testzipcode_${testZipcode}`;
  const state = window.RetiqueGeoLocatorOverride = window.RetiqueGeoLocatorOverride || {};
  state.testZipcode = testZipcode;
  state.getCoordinates = getCoordinates;
  state.applyStorepointUrlOverride = applyStorepointUrlOverride;

  try {
    const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
    if (cached && Number.isFinite(cached.latitude) && Number.isFinite(cached.longitude)) {
      state.coordinates = cached;
      applyStorepointUrlOverride(cached);
      overrideGeolocation(cached);
      preserveZipcodeOnLinks();
      return;
    }
  } catch {}

  applyStorepointUrlOverride();
  preserveZipcodeOnLinks();

  getCoordinates().then((coordinates) => {
    if (!coordinates) return;
    state.coordinates = coordinates;
    try { sessionStorage.setItem(cacheKey, JSON.stringify(coordinates)); } catch {}
    applyStorepointUrlOverride(coordinates);
    overrideGeolocation(coordinates);
  });

  function getCoordinates() {
    if (state.coordinates) return Promise.resolve(state.coordinates);

    return fetch(`https://api.zippopotam.us/us/${encodeURIComponent(testZipcode.slice(0, 5))}`, {
      credentials: 'omit',
    })
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        const place = data?.places?.[0];
        const latitude = Number(place?.latitude);
        const longitude = Number(place?.longitude);
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
        return { latitude, longitude, zipcode: testZipcode };
      })
      .catch(() => null);
  }

  function overrideGeolocation(coordinates) {
    const geo = navigator.geolocation;
    if (!geo || geo.__rtqTestZipcodeOverride) return;

    const position = {
      coords: {
        latitude: coordinates.latitude,
        longitude: coordinates.longitude,
        accuracy: 1000,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        speed: null,
      },
      timestamp: Date.now(),
    };

    const original = {
      getCurrentPosition: geo.getCurrentPosition?.bind(geo),
      watchPosition: geo.watchPosition?.bind(geo),
      clearWatch: geo.clearWatch?.bind(geo),
    };

    geo.getCurrentPosition = function getCurrentPosition(success) {
      if (typeof success === 'function') {
        setTimeout(() => success(position), 0);
      }
    };

    geo.watchPosition = function watchPosition(success) {
      if (typeof success === 'function') {
        setTimeout(() => success(position), 0);
      }
      return 1;
    };

    geo.clearWatch = function clearWatch(id) {
      if (original.clearWatch && id !== 1) original.clearWatch(id);
    };

    Object.defineProperty(geo, '__rtqTestZipcodeOverride', {
      value: true,
      configurable: true,
    });
  }

  function applyStorepointUrlOverride(coordinates) {
    const url = new URL(window.location.href);
    let changed = false;

    if (url.searchParams.get('locate') !== testZipcode) {
      url.searchParams.set('locate', testZipcode);
      changed = true;
    }

    if (url.searchParams.get('search_text') !== testZipcode) {
      url.searchParams.set('search_text', testZipcode);
      changed = true;
    }

    if (coordinates) {
      const lat = String(coordinates.latitude);
      const lng = String(coordinates.longitude);
      if (url.searchParams.get('lat') !== lat) {
        url.searchParams.set('lat', lat);
        changed = true;
      }
      if (url.searchParams.get('lng') !== lng) {
        url.searchParams.set('lng', lng);
        changed = true;
      }
    }

    if (changed) {
      window.history.replaceState({}, '', url.toString());
    }
  }

  function preserveZipcodeOnLinks() {
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      if (!link.matches('[data-sp-open], a[href*="/pages/store-locator"]')) return;

      try {
        const url = new URL(link.href, window.location.href);
        if (url.searchParams.get('testzipcode') === testZipcode) return;
        url.searchParams.set('testzipcode', testZipcode);
        link.href = url.toString();
      } catch {}
    }, true);
  }
})();
